import React, { PropTypes } from 'react'

function ProductApplications(props) {
	return (
		<table>
			<caption>Applications</caption>
			<tbody>
				<tr>
					<td width="40%">Boilers</td>
					<td>Prevents particulate deposit build-up and increases heat transfer efficiency</td>
				</tr>
				<tr>
					<td>Precipitators</td>
					<td>Prevents:
						<ul>
							<li>Distribution plate plugging</li>
							<li>Collecting plate build-up</li>
							<li>Electrode build-up</li>
							<li>Hopper pluggage</li>
							<li>Complete elimination of tumbling hammer rapping systems</li>
						</ul>
					</td>
				</tr>
				<tr>
					<td>Selective Catalytic Reduction (SCR)</td>
					<td>Prevents deposit build-up on catalyst modules</td>
				</tr>
				<tr>
					<td>Economizers</td>
					<td>Prevents deposit build up on boiler tubes</td>
				</tr>
				<tr>
					<td>Baghouses</td>
					<td>
						Prevents:
						<ul>
							<li>Short bag life</li>
							<li>High pressure drop</li>
							<li>Hopper pluggage</li>
						</ul>
					</td>
				</tr>
				<tr>
					<td>Hoppers / Silos</td>
					<td>
						Prevents:
						<ul>
							<li>Plugging</li>
							<li>Material flow problems such as bridging and ratholing</li>
							<li>Deposit build-up</li>
						</ul>
					</td>
				</tr>
				<tr>
					<td>Ductwork / Breeching</td>
					<td>
						Prevents:
						<ul>
							<li>Excessive fallout</li>
							<li>Deposit build-up</li>
						</ul>
					</td>
				</tr>
				<tr>
					<td>Fans</td>
					<td>Prevents out of balance conditions</td>
				</tr>
				<tr>
					<td>Air Pre-Heaters</td>
					<td>Prevents particulate deposit build-up and increases heat transfer efficiency</td>
				</tr>
			</tbody>
		</table>
	)
}

ProductApplications.propTypes = {

}

ProductApplications.defaultProps = {

}

export default ProductApplications



// WEBPACK FOOTER //
// ../components/Product/ProductApplications.js